import React from 'react'
import IconButton from '@mui/material/IconButton';
import colors from '../colors';
import { Dialog, Grid, DialogTitle, DialogContent, DialogActions, Button, Link, Slide, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { sendGeneralRequest } from '../../features/generalRequest'
import { useSelector, useDispatch } from 'react-redux';
import {selectLoginState, setShouldDisplayTermsAndConditionsPopUp} from '../../features/login/loginSlice'
import {texts} from '../general/texts'

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });

export const AcceptNewTermsAndConditions = () => {
  
    const dispatch = useDispatch()
    const [isOpen, setIsOpen] = React.useState(false)
    const loginSliceState = useSelector(selectLoginState)

    const openInNewTab = (url) => 
    {
      const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
      if (newWindow) newWindow.opener = null
    }

    const onClickUrl = (url) => 
    {
        return () => openInNewTab(url)
    }

    React.useEffect(()=>{
      loginSliceState.shouldDisplayTermsAndConditionsPopUp && setIsOpen(true)
      !loginSliceState.shouldDisplayTermsAndConditionsPopUp && setIsOpen(false)
      },[loginSliceState.shouldDisplayTermsAndConditionsPopUp])


    return (
    <Grid>
        <Dialog
            open={isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={() => {dispatch(setShouldDisplayTermsAndConditionsPopUp(false))}}
            fullScreen={false}
            PaperProps={{style: { borderRadius: '20px', marginTop:'10%'}}}
            aria-describedby="alert-dialog-slide-description"
        >
            <DialogTitle sx={{background:colors.gradientOrange, color:colors.white, textAlign:"center", padding:"3.5%", fontFamily:'GerberaMedium'}}>{texts["title-terms-and-conditions"]}</DialogTitle>
            <DialogContent sx={{textAlign:'center'}} >
                <Typography sx={{pt:'5%', color:colors.darkBlue, fontSize:'1.2rem', fontFamily:'GerberaLight'}} >
                    {texts["message-accept-terms"]}
                </Typography>
            </DialogContent>
            <DialogActions sx={{justifyContent:'center'}}>
                <Button onClick={() => {dispatch(sendGeneralRequest({request: {_request: {token: loginSliceState.token, idTC: loginSliceState.termsAndConditionsId, accountType:loginSliceState.accountType  }}, baseUrlKey:'auth', endpoint:'AcceptTermsAndConditions'}))}} sx={{background:colors.gradientOrange, borderRadius:'10px', color:colors.white , paddingLeft:'3%',paddingRight:'3%'}} >{texts["button-confirm"]}</Button>        
            </DialogActions>
            <DialogActions sx={{justifyContent:'center'}}>
                <Link onClick={onClickUrl(loginSliceState.termsAndConditionsURL)} sx={{ borderRadius:'5px', color:colors.darkBlue,textDecoration:'none', paddingBottom:'2%', fontFamily:'GerberaLight' }} component='button'>{texts["button-read"]}</Link>
            </DialogActions>
        </Dialog>

    </Grid>
  )
}
